			<div class="row my-2">
				<form id="formChooseIntervenant" [formGroup]="formChooseIntervenant" (ngSubmit)="submitFormChooseIntervenant()" *ngIf="formChooseIntervenant">
					<!-- <div class="row my-4">
						<div class="col-12 col-lg">
							<label for="inputDateDebut" class="form-label theme-main-color fw-bold"
								>Date de démarrage</label
							>
							<span class="row my-2" id="dateDebut">{{
								dateDebut | date : 'dd/MM/YYYY HH:mm'
							}}</span>
						</div>
					</div> -->
					<div class="row my-4">
						<div class="col-12 col-lg">
							<label for="inputAddresse" class="form-label theme-main-color fw-bold"
								>Localisation</label
							>
							<input
								autocomplete="off"
								type="text"
								class="form-control"
								id="inputAddresse"
								name="address"
								[typeahead]="addressList"
								[typeaheadAsync]="true"
								typeaheadOptionField="displayName"
								(typeaheadLoading)="changeTypeaheadLoading($event)"
								formControlName="address"
								(keyup)="selectedAddressKeyUp($event.target)"
								(typeaheadOnSelect)="onAddressSelect($event)"
							/>
						</div>
					</div>
				
					<div class="row my-4">
						<div class="col-12 col-lg">
							<label for="expertises" class="form-label fw-bold">Expertises :</label>
							<div class="row">
								<div
									class="col-md-4 check"
									*ngFor="let expertise of listExpertise | orderBy : 'name' : 'asc'"
								>
								<div *ngIf="expertise.id !== 0">
									<input
										type="checkbox"
										name="{{ expertise.id }}"
										class="form-check-input"
										[value]="expertise"
										[checked]="isExpertiseCheck(expertise)"
										[ngClass]="{
											'theme-main-color-check': isExpertiseCheck(expertise)
										}"
										(change)="updateSelectedExpertise($event, expertise)"
									/>
									<label class="ms-2 form-check-label text-dark">
										{{ expertise.name }}
									</label>
								</div>
							</div>
							</div>
						</div>
				
					</div>
				
					<div class="row my-5">
						<div class="d-flex justify-content-end">
							<button
								[disabled]="!formChooseIntervenant.valid || !(isAddressDefault.value || isAddressSelected.value)
								"
								class="btn theme-green-button"
								type="submit"
								form="formChooseIntervenant"
							>
								<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Valider
							</button>
						</div>
					</div>
				</form>
				
			</div>
